import { defineFinderKind } from "./define-finder-kind";

function scheduling(payload, settings) {
  return {
    slotsUi: payload.slots_ui,
    startDate: payload.appointment_grid?.start_date,
    showYear: payload.slot_show_year || "never",
    maxSlots: 3,
    slotButtonVariant: payload.slot_button_variant,
    moreButtonVariant: payload.more_button_variant,
    cardElevation: payload.card_elevation,
    fullSchedulePlacement: payload.full_schedule_placement,
    fullScheduleDirection: payload.full_schedule_direction,
    showMultipleSchedulingTypes: settings?.result?.showMultipleSchedulingTypes,
    doctorMessages: settings?.doctorMessages ?? true,
  };
}

function resultProperties({ payload, settings }) {
  const resultConfig = settings?.result ?? {};
  return {
    layout: resultConfig.resultTemplate === "directory" ? "directory" : "bio",
    resultConfig,
    labels: { noAddress: settings?.noAddressLabel },
    scheduling: scheduling(payload, settings),
  };
}

export default defineFinderKind({
  name: "provider",
  results: { Physician: "sp-finder-provider-result", Location: "sp-finder-location-result" },
  resultProperties,
  listInserts: [{ after: 5, element: "sp-finder-map-banner", whenFewer: "end" }],
  requests: {
    // The days the go-to-date calendar marks: open slot counts keyed by date.
    dateAvailability: { url: (settings) => settings?.results?.availabilityUrl },
  },
});
